import { Entity } from '../../../core/context/entity';
import { UUID } from '../../../core/context/uuid/entity';

interface ThreatVectorMitigationProps {
    id: string;
    name: string;
    responsibilityId: string;
    description: string;
    threatVectorId: string;
    mitigationId?: string;
    exploitabilityId?: string;
    exposureId?: string;
    impactId?: string;
    exploitabilityComment?: string;
    exposureComment?: string;
    impactComment?: string;
}

export class ThreatVectorMitigation
    extends Entity
    implements ThreatVectorMitigationProps
{
    name: string;
    responsibilityId: string;
    description: string;
    threatVectorId: string;
    mitigationId?: string;
    exploitabilityId?: string | undefined;
    exposureId?: string | undefined;
    impactId?: string | undefined;
    exploitabilityComment?: string | undefined;
    exposureComment?: string | undefined;
    impactComment?: string | undefined;

    constructor({
        id,
        name,
        description,
        responsibilityId,
        threatVectorId,
        mitigationId,
        exposureId,
        exploitabilityId,
        impactId,
        exploitabilityComment,
        exposureComment,
        impactComment,
    }: ThreatVectorMitigationProps) {
        super({ id });
        this.name = name;
        this.description = description;
        this.responsibilityId = responsibilityId;
        this.threatVectorId = threatVectorId;
        this.mitigationId = mitigationId;
        this.exposureId = exposureId;
        this.exploitabilityId = exploitabilityId;
        this.impactId = impactId;
        this.exploitabilityComment = exploitabilityComment;
        this.exposureComment = exposureComment;
        this.impactComment = impactComment;
    }

    static new(
        props: Omit<ThreatVectorMitigationProps, 'id'>,
    ): ThreatVectorMitigation {
        const uuid = new UUID();
        return new ThreatVectorMitigation({
            id: uuid.toString(),
            ...props,
        });
    }
}
